import React from "react"

import {ProjectAccess, ProjectAccessDescriptionDictionary, ProjectAccessLabelDictionary} from "../../gd/const/project"
import FieldsFactory from "../../fields3/fields-factory"
import {FieldType} from "../../fields3/field-type"
import FieldInlineEditable from "../../fields3/render/inline-editable"
import ProjectUsersFullCollection from "../../model2/project-user/collection-full";

type Props = {
    className?      : string

    mode            : 'existing-user' | 'new-user'

    renderValue     : 'text-12' | 'text-13'

    value           : number                    // current value
    accessLevels    : ProjectAccess[]
    onSelect        : func                      // onSelect callback
    projectId       : ID                        // project we select access for

    projectUsers?   : ProjectUsersFullCollection    // THIS IS NOT session - this is full data collection at the mom it's collection
    projectUser?    : any                       // THIS IS NOT session - projectUser we are about to edit
    userId          : ID                        // for organization full access or inheritance check if no projectUser specified
}

export default class SelectProjectAccess extends React.Component<Props> {

    static defaultProps = {
        value: ProjectAccess.STANDARD,
        accessLevels: [
            ProjectAccess.READ_ONLY,
            ProjectAccess.CLIENT,
            ProjectAccess.LIMITED,
            ProjectAccess.STANDARD,
            ProjectAccess.FULL
        ]
    };

    onSelect = (newValue: any) => {
        if (this.props.onSelect) this.props.onSelect(newValue);
    }

    getNewUserAccessOptions() {
        const projectUser = this.props.projectUser;
        const userId = projectUser ? projectUser.userId : this.props.userId;

        // ok make sure user cannot pick access higher than his access
        const curUserProjectAccess = gd.session.projects.get(this.props.projectId)?.access;

        let res: ProjectAccess[] = []

        // if user is organization full access user he can be full access only
        if (gd.ac.check.company.isFullAccess(userId)) {
            res = [ProjectAccess.FULL];
        } else {
            switch (curUserProjectAccess) {
                case ProjectAccess.LIMITED: /*do nothing*/ break;

                case ProjectAccess.STANDARD:
                    res = [
                        ProjectAccess.READ_ONLY,
                        ProjectAccess.CLIENT,
                        ProjectAccess.LIMITED,
                        ProjectAccess.STANDARD,
                    ];
                    break;

                case ProjectAccess.FULL:
                    res = [
                        ProjectAccess.READ_ONLY,
                        ProjectAccess.CLIENT,
                        ProjectAccess.LIMITED,
                        ProjectAccess.STANDARD,
                        ProjectAccess.FULL,
                    ];
                    break;
            }
        }

        return _.intersection(this.props.accessLevels, res);
    }

    getExistingUserAccessOptions() {
        let res = []

        const projectUsers = this.props.projectUsers;
        const projectUser = this.props.projectUser;
        const userId = projectUser ? projectUser.userId : this.props.userId;
        const fullAccessUsers = projectUsers?.findFullAccessUsers();
        const access = this.props.value;

        // if user is organization full access user he can be full access only
        if (gd.ac.check.company.isFullAccess(userId)) {
            res = [ProjectAccess.FULL];
        }
        // if user is owner or project manager he can be full access only...
        else if (projectUser.projectRole === gd.const.project.role.OWNER || projectUser.projectRole === gd.const.project.role.PROJECT_MANAGER) {
            res = [ProjectAccess.FULL];
        }
        // if we have only one full access user and we are editing him - make sure only full is an option
        else if (fullAccessUsers?.length === 1 && projectUser.access === ProjectAccess.FULL) {
            res = [ProjectAccess.FULL];
        }
        else if (projectUser.inheritance === gd.const.project.userInheritance.INHERITED) {
            let inheritedAccess = access;
            const allUserProjects = gd.session.projectUsers.filterByUser(userId);
            const parentProject = gd.tree.getProject(projectUser.projectId)?.parent;

            const pu =_.find(allUserProjects.models, m=>m.project.id === parentProject?.id);

            if (pu && pu.access < inheritedAccess) inheritedAccess = pu.access;

            if (inheritedAccess <= ProjectAccess.FULL)          res.push(ProjectAccess.FULL);
            if (inheritedAccess <= ProjectAccess.STANDARD)      res.push(ProjectAccess.STANDARD);
            if (inheritedAccess <= ProjectAccess.LIMITED)       res.push(ProjectAccess.LIMITED);
            if (inheritedAccess <= ProjectAccess.CLIENT)        res.push(ProjectAccess.CLIENT);
            if (inheritedAccess <= ProjectAccess.READ_ONLY)     res.push(ProjectAccess.READ_ONLY);
        } else {
            res = [
                ProjectAccess.READ_ONLY,
                ProjectAccess.CLIENT,
                ProjectAccess.LIMITED,
                ProjectAccess.STANDARD,
                ProjectAccess.FULL,
            ];
        }

        return _.intersection(this.props.accessLevels, res);
    }

    render() {
        let accessOptions = [];
        switch (this.props.mode) {
            case 'new-user':        accessOptions = this.getNewUserAccessOptions(); break;
            case 'existing-user':   accessOptions = this.getExistingUserAccessOptions(); break;
        }

        const customAccessOptions = [
            {
                value           : ProjectAccess.FULL,
                label           : ProjectAccessLabelDictionary[ProjectAccess.FULL],
                description     : ProjectAccessDescriptionDictionary[ProjectAccess.FULL],
                disabled        : !accessOptions.includes(ProjectAccess.FULL),
            },
            {
                value           : ProjectAccess.STANDARD,
                label           : ProjectAccessLabelDictionary[ProjectAccess.STANDARD],
                description     : ProjectAccessDescriptionDictionary[ProjectAccess.STANDARD],
                disabled        : !accessOptions.includes(ProjectAccess.STANDARD),
            },
            {
                value           : ProjectAccess.LIMITED,
                label           : ProjectAccessLabelDictionary[ProjectAccess.LIMITED],
                description     : ProjectAccessDescriptionDictionary[ProjectAccess.LIMITED],
                disabled        : !accessOptions.includes(ProjectAccess.LIMITED),
            },

            {
                value           : ProjectAccess.CLIENT,
                label           : ProjectAccessLabelDictionary[ProjectAccess.CLIENT],
                description     : ProjectAccessDescriptionDictionary[ProjectAccess.CLIENT],
                notSelectable   : true,
                disabled        : !accessOptions.includes(ProjectAccess.CLIENT),
            },
            {
                value           : ProjectAccess.READ_ONLY,
                label           : ProjectAccessLabelDictionary[ProjectAccess.READ_ONLY],
                description     : ProjectAccessDescriptionDictionary[ProjectAccess.READ_ONLY],
                disabled        : !accessOptions.includes(ProjectAccess.READ_ONLY),
            },
        ]

        const field = FieldsFactory.get({
            fieldId : 'access',
            type    : FieldType.PROJECT_ACCESS,
            options : customAccessOptions
        })

        return <FieldInlineEditable className   = {Classes('select-access', this.props.className)}
                                    field       = {field}
                                    model       = {{
                                        access: this.props.value,
                                    }}
                                    onChange    = {this.onSelect} />
    }
}